import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom';

import DigitalLetterSent from './DigitalLetterSent';
import DigitalLetterDetailsSent from './DigitalLetterDetailsSent';

export default function DigitalLetterSentMain() {
    const [showSentList, setShowSentList] = useState(true);
    const location = useLocation();

    const details = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('details');
    }, [location.search]);

    useEffect(() => {
      setShowSentList(details !== 'true');
    }, [details]);

    return showSentList ? <DigitalLetterSent /> : <DigitalLetterDetailsSent />;
}
